/* @flow */
import Checkbox from 'components/Checkbox.jsx';
import CurrentUser from 'auth/CurrentUser';
import Legend from 'components/Legend.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';

const INCLUDE_IN_OWN_BROADCASTS_PREF = 'include_in_own_broadcasts';

const NotificationSettingsViewPreferences = React.createClass({

  getInitialState() {
    return {
      includeInOwnBroadcasts: CurrentUser.getUser().getPreference(INCLUDE_IN_OWN_BROADCASTS_PREF),
    };
  },

  // typecheck: ignore statement
  handleChange(e: SyntheticInputEvent) {
    const includeInOwnBroadcasts = e.target.checked;

    const onSuccess = () => {
      this.setState({ includeInOwnBroadcasts });
      const message = includeInOwnBroadcasts ?
        'You will receive copies of your class announcements' :
        'You will no longer receive copies of your class announcements';
      ToastActions.showSuccessToast(message);
    };

    const onError = () => {
      ToastActions.showErrorToast('Failed to save preference');
    };

    CurrentUser.getUser()
      .savePreference(INCLUDE_IN_OWN_BROADCASTS_PREF, includeInOwnBroadcasts)
      .then(onSuccess, onError);
  },

  render() {
    return (
      <div>
        <Legend>Preferences</Legend>
        <div
          className="NotificationSettingsView-device">
          <Checkbox
            label="Receive copies of your class announcements"
            onChange={this.handleChange}
            defaultChecked={this.state.includeInOwnBroadcasts}
          />
        </div>
      </div>
    );
  },

});

export default NotificationSettingsViewPreferences;



// WEBPACK FOOTER //
// ./src/settings/components/NotificationSettingsViewPreferences.jsx